const pubSub = (() => {
    const events = {};

    const subscribe = (name, callback, initialTrigger) => {
        if (!events[name]) {
            events[name] = [];
        }

        const index = events[name].push(callback) - 1;

        if (initialTrigger) {
            pubSub.publish(name);
        }

        return {
            remove: () => {
                delete events[name][index];
            },
        };
    };

    const publish = (name, data) => {
        if (!events[name]) {
            return;
        }

        events[name].forEach(event => {
            if (typeof event === "function") {
                event(data || {});
            }
        });
    };

    return {
        subscribe,
        publish,
    };
})();

export default pubSub;
